/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('DataValidatorServiceApi', ($http, ApiErrorService) => {
    return {
        dvFiles: dvFiles,
        simulatorDvFilesForUser: simulatorDvFilesForUser,
        dvFileByTraceUid: dvFileByTraceUid,
        connectedUser: connectedUser,
        uploadFile: uploadFile,
        resendFile: resendFile,
        simIsActive: simIsActive
    };
    function dvFiles(testerId) {
        return $http.post(`api/DataValidator/DvFiles?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function simulatorDvFilesForUser(testerId, simId) {
        return $http.get(`api/DataValidator/SimulatorDvFilesForUser?testerId=${testerId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function dvFileByTraceUid(traceUid) {
        return $http.post(`api/DataValidator/DvFile?traceUid=${encodeURIComponent(traceUid)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function connectedUser() {
        return $http.post(`api/DataValidator/ConnectedUser`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function uploadFile(request, userId, simId) {
        return $http.post(`api/DataValidator/UploadFile?userId=${userId}&simId=${simId}`, request)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function resendFile(fileId, simId) {
        return $http.post(`api/DataValidator/ResendFile?fileId=${fileId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function simIsActive(testerId, simId) {
        return $http.get(`api/DataValidator/SimIsActive?testerId=${testerId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
